import { QueryClient } from '@tanstack/react-query';

/**
 * TanStack Query client configuration.
 * Centralized caching, retry logic, and stale time settings.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Data is considered fresh for 1 minute
      staleTime: 1000 * 60,
      // Cache is garbage collected after 5 minutes
      gcTime: 1000 * 60 * 5,
      // Retry logic - don't retry on 4xx errors
      retry: (failureCount, error) => {
        // Don't retry on client errors (4xx)
        if (error instanceof Error && 'status' in error) {
          const status = (error as { status: number }).status;
          if (status >= 400 && status < 500) {
            return false;
          }
        }
        // Retry up to 3 times for other errors
        return failureCount < 3;
      },
      // Refetch when window regains focus
      refetchOnWindowFocus: true,
      // Don't refetch on mount if data is fresh
      refetchOnMount: true,
    },
    mutations: {
      // Don't retry mutations by default
      retry: false,
    },
  },
});
